module.exports = __webpack_public_path__ + "470c0cc8f3a543c120d47c2ec378c057.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-2.png
// module id = 2460
// module chunks = 0